var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16a3.067 3.067 0 011.04-2.305L21.909.614a2.462 2.462 0 013.252 3.698L12.158 15.751a.334.334 0 000 .501l13.003 11.439a2.462 2.462 0 11-3.251 3.697L7.046 18.311a3.075 3.075 0 01-1.045-2.309z"
  })));
}
export default SvgArrowLeft;